const marginXaxis = 20;

export const fast_track = [
    { style: 'textBold', margin: [marginXaxis, 5], translate: 'title' },
    { margin: [marginXaxis, 0], style: 'text', translate: 'p-1' },
    { margin: [20, 0], style: 'text', translate: 'p-2' },
    { margin: [marginXaxis, 20], style: 'text', translate: 'p-3' },
];

export const vip_lounge = [
    { style: 'textBold', margin: [marginXaxis, 5], translate: 'title' },
    { margin: [marginXaxis, 0], style: 'text' , translate: 'p-1'},
    { margin: [20, 0], style: 'text' , translate: 'p-2'},
    { style: 'textBold', margin: [marginXaxis, 5, marginXaxis, 0] , translate: 'p-3'},
    { margin: [marginXaxis, 0], style: 'text', translate: 'p-4' },
    { margin: [marginXaxis, 40], style: 'text', translate: 'p-5' },
];

export const vip_card = [
    { style: 'textBold', margin: [marginXaxis, 5] , translate: 'title' },
    { margin: [marginXaxis, 0], style: 'text', translate: 'p-1' },
    { margin: [marginXaxis, 20], style: 'text', translate: 'p-2' }
];

export const honor_card = [
    { style: 'textBold', margin: [marginXaxis, 5] , translate: 'title' },
    { margin: [marginXaxis, 0], style: 'text', translate: 'p-1' },
    { margin: [marginXaxis, 20], style: 'text', translate: 'p-2' }
];

export const bgy_go = [
    { style: 'textBold', margin: [marginXaxis, 5], translate: 'title' },
    { margin: [marginXaxis, 0], style: 'text', translate: 'p-1' },
    { margin: [20, 0], style: 'text', translate: 'p-2' },
    { margin: [marginXaxis, 0], style: 'text', translate: 'p-3' },
    { margin: [marginXaxis, 20], style: 'text', translate: 'p-4' }
];

export const bgy_top = [
    { style: 'textBold', margin: [marginXaxis, 5], translate: 'title' },
    { margin: [marginXaxis, 0], style: 'text', translate: 'p-1' },
    { margin: [20, 0], style: 'text', translate: 'p-2' },
    { margin: [marginXaxis, 0], style: 'text', translate: 'p-3' },
    { margin: [marginXaxis, 20], style: 'text', translate: 'p-4' }
];

export const fast_track_plus = [
    { text: 'MODALITÀ DI UTILIZZO:', style: 'textBold', margin: [marginXaxis, 5], translate: 'title' },
    { text: 'Gentile Cliente, la ringraziamo per aver acquistato il nostro FAST TRACK PLUS.', margin: [marginXaxis, 0], style: 'text', translate: 'p-1' },
    { text: 'Stampi, porti con sé questo documento cercando di non piegare o rovinare il qrcode (codice quadrato) di seguito riportato e lo esponga al lettore che troverà all’ingresso della corsia dedicata al Check-In Lounge per aver un accesso immediato al servizio.', margin: [20, 0], style: 'text', translate: 'p-2' },
    { text: 'In mancanza di tale codice non sarà possibile l’autenticazione del suo servizio da parte del personale dell’aeroporto e la fruizione del medesimo.', margin: [marginXaxis, 20], style: 'text', translate: 'p-3' },
];

export const batt_volo = [
    { style: 'textBold', margin: [marginXaxis, 5] , translate: 'title' },
    { margin: [marginXaxis, 0], style: 'text', translate: 'p-1' },
    { margin: [marginXaxis, 20], style: 'text', translate: 'p-2' }
];

export const combo = [
    { style: 'textBold', margin: [marginXaxis, 5] , translate: 'title' },
    { margin: [marginXaxis, 0], style: 'text', translate: 'p-1' },
    { margin: [marginXaxis, 20], style: 'text', translate: 'p-2' },
    { margin: [marginXaxis, 20], style: 'text', translate: 'p-3' },
    { margin: [marginXaxis, 20], style: 'text', translate: 'p-4' },
];

export const park = [
    { style: 'textBold', margin: [marginXaxis, 5] , translate: 'title' },
    { style: 'textBold', margin: [marginXaxis, 5] , translate: 'subtitle' },
    { style: 'textUnderline', margin: [marginXaxis, 0], translate: 'instructions-p1' },
    { style: 'textBold', margin: [marginXaxis, 5], translate: 'p-p1-1' },
    { margin: [marginXaxis, 0], style: 'text', translate: 'p-p1-2' },
    { style: 'textBold', margin: [marginXaxis, 5], translate: 'p-p1-3' },
    { margin: [marginXaxis, 0], style: 'text', translate: 'p-p1-4' },
    { style: 'textBold', margin: [marginXaxis, 5], translate: 'p-p1-5' },
    { margin: [marginXaxis, 0], style: 'text', translate: 'p-p1-6' },
    { margin: [marginXaxis, 5], style: 'text', color: '#ff1205', translate: 'p-p1-7' },
    { style: 'textUnderline', margin: [marginXaxis, 0], translate: 'instructions-2' },
    { margin: [marginXaxis, 0], style: 'text', translate: 'p-4' },
    { style: 'textBold', margin: [marginXaxis, 5], translate: 'p-5' },
    { margin: [marginXaxis, 0], style: 'text', translate: 'p-6' },
    { style: 'textUnderline', margin: [marginXaxis, 0], translate: 'instructions-1' },
    { margin: [marginXaxis, 0], style: 'text', translate: 'p-1' },
    { style: 'textBold', margin: [marginXaxis, 5], translate: 'p-2' },
    { margin: [marginXaxis, 0], style: 'text', translate: 'p-3' }
];

export const porteraggio = [
    { style: 'textBold', margin: [marginXaxis, 5] , translate: 'title' },
    { margin: [marginXaxis, 0], style: 'text', translate: 'p-1' },
    { margin: [marginXaxis, 20], style: 'text', translate: 'p-2' },
    { margin: [marginXaxis, 20], style: 'text', translate: 'p-3' },
    { margin: [marginXaxis, 20], style: 'text', translate: 'p-4' },
];

export const dif = [
    { style: 'textBold', margin: [marginXaxis, 5] , translate: 'title' },
    { margin: [marginXaxis, 0], style: 'text', translate: 'p-1' },
    { margin: [marginXaxis, 20], style: 'text', translate: 'p-2' },
    { margin: [marginXaxis, 20], style: 'text', translate: 'p-3' },
];
